<template>
  <div
    class="chat__contact flex items-center px-4 py-4"
    :class="{'bg-primary-gradient text-white shadow-lg': isActiveChatUser}"
  >
    <div class="contact__container w-full flex items-center justify-between overflow-hidden pl-2">
      <div class="contact__info flex flex-col truncate w-5/6">
        <h5 class="font-semibold" :class="{'text-white': isActiveChatUser}">{{ contact.name }}</h5>
        <span class="truncate mt-4">{{ contact.lastmessage }}</span>
      </div>

      <div class="chat__contact__meta flex self-start flex-col items-end w-1/6">
        <span class="whitespace-no-wrap">{{ lastMessaged | formatDateTimeNoSeconds }}</span>
        <vs-avatar color="primary" :text="`${contact.unread_count}`" size="20px" v-if="contact.unread_count" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    contact: {
      type: Object,
      required: true
    },
    lastMessaged: {
      type: String,
      default: ""
    },
    unseenMsg: {
      type: Number,
      default: 0
    },
    isActiveChatUser: {
      type: Boolean
    }
  }
};
</script>
